import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";

import Container from "@material-ui/core/Container";

import MainPage from "./components/orders/MainPage";
import AcceptingOrder from "./components/orders/newOrders/orderResponse/AcceptingOrder";
import RejectingOrder from "./components/orders/newOrders/orderResponse/RejectingOrder";
import Login from "./components/authentication/Login.js";
import Notifications from "./components/notifications/Notifications";
import DeliveryboyPage from "./components/deliveryboy/DeliveryboyPage";
import RegisterDeliveryboy from "./components/deliveryboy/RegisterDeliveryBoy";
// import SSE from "../../seller/src/sse";
import Header from "./components/header/Header";
import SalesChart from "./components/sales/SalesChart";
import SalesHistory from "./components/sales/SalesHistory";
import AddItem from "./components/management/AddItem";
import ShopManagement from "./components/management/ShopManagement";
import OrderAssignment from "./components/orders/deliveringOrders/OrderAssignment";
import FirebasePhoneAuth from "./components/authentication/FirebasePhoneAuth";
import BlockAccountPage from "./components/authentication/BlockAccountPage";
import UpdateItem from "./components/management/UpdateItem";
import Reviews from "./components/Reviews";
import Complaints from "./components/Complaints";
import Receipt from "./components/Receipt";
// import whyDidYouRender from "@welldone-software/why-did-you-render";
// whyDidYouRender(React, {
//   onlyLogs: true,
//   titleColor: "green",
//   diffNameColor: "darkturquoise",
//   trackAllPureComponents: true,
// });
export default function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Route component={Header} />
          <Switch>
            <Container>
              <Route exact path="/" component={Login} />
              <Route exact path="/dashboard/:ID" component={MainPage} />
              <Route
                exact
                path="/order/assignment/:orderID"
                component={OrderAssignment}
              />

              <Route
                exact
                path="/order/accept/:orderID"
                component={AcceptingOrder}
              />
              <Route
                exact
                path="/order/reject/:orderID"
                component={RejectingOrder}
              />
              <Route
                exact
                path="/notifications/:name/:sellerId"
                component={Notifications}
              />
              <Route exact path="/receipt/:orderId" component={Receipt} />

              <Route
                exact
                path="/sales/chart/:sellerId"
                component={SalesChart}
              />

              <Route
                exact
                path="/shop/history/:sellerId"
                component={SalesHistory}
              />
              <Route
                exact
                path="/shop/management/:sellerID"
                component={ShopManagement}
              />
              <Route exact path="/add/item" component={AddItem} />
              <Route exact path="/shop/reviews/:shopId" component={Reviews} />
              <Route
                exact
                path="/shop/complaints/:shopId"
                component={Complaints}
              />
              <Route exact path="/update/item/:itemId" component={UpdateItem} />
              <Route exact path="/deliveryboy" component={DeliveryboyPage} />
              <Route
                exact
                path="/register/deliveryboy"
                component={RegisterDeliveryboy}
              />
              <Route
                exact
                path="/forgot/password"
                component={FirebasePhoneAuth}
              />
              <Route
                exact
                path="/seller/blocked"
                component={BlockAccountPage}
              />
            </Container>
          </Switch>
        </Router>
      </PersistGate>
    </Provider>
  );
}
